webpackJsonp([127991906165095],{

/***/ 1519:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProductManufacturerInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-product-manufacturer-input-09394c3198e064a02c66.js